import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { ScheduledDate } from './schedule-date.model';
import { IGenericResponse, IDeleteEntity } from '../../shared';

export const loadScheduledDates = createAction(
    '[ScheduledDate/API] Load ScheduledDates',
    props<{ scheduledDates: ScheduledDate[] }>()
);

export const addScheduledDate = createAction(
    '[ScheduledDate/API] Add ScheduledDate',
    props<{ scheduledDate: ScheduledDate }>()
);

export const upsertScheduledDate = createAction(
    '[ScheduledDate/API] Upsert ScheduledDate',
    props<{ scheduledDate: ScheduledDate }>()
);

export const addScheduledDates = createAction(
    '[ScheduledDate/API] Add ScheduledDates',
    props<{ scheduledDates: ScheduledDate[] }>()
);

export const upsertScheduledDates = createAction(
    '[ScheduledDate/API] Upsert ScheduledDates',
    props<{ scheduledDates: ScheduledDate[] }>()
);

export const updateScheduledDate = createAction(
    '[ScheduledDate/API] Update ScheduledDate',
    props<{ scheduledDate: Update<ScheduledDate> }>()
);

export const updateScheduledDates = createAction(
    '[ScheduledDate/API] Update ScheduledDates',
    props<{ scheduledDates: Update<ScheduledDate>[] }>()
);

export const deleteScheduledDate = createAction(
    '[ScheduledDate/API] Delete ScheduledDate',
    props<{ id: string }>()
);

export const deleteScheduledDates = createAction(
    '[ScheduledDate/API] Delete ScheduledDates',
    props<{ ids: string[] }>()
);

export const clearScheduledDates = createAction(
    '[ScheduledDate/API] Clear ScheduledDates'
);
export const getScheduledDates = createAction(
    '[ScheduledDate/API] Get ScheduledDates',
    props<{ ShowAll: boolean }>()
);
export const getScheduledDatesFailure = createAction(
    '[ScheduledDate/API] Get ScheduledDates Failure',
    props<{ error: IGenericResponse<IDeleteEntity> }>()
);
